import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

// Skeleton for Balance by Category (Pie Chart + Amounts)
export const BalanceByCategorySkeleton = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        marginTop: "1rem",
      }}
    >
      {/* Left side: Category Table Skeleton */}
      <div style={{ width: "60%" }}>
        {/* Table rows */}
        {[1].map((row) => (
          <div
            key={row}
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "0.8rem",
              flexDirection: "column",
            }}
          >
            <div
              className="skeleton"
              style={{ width: "55%", height: "16px" }}
            ></div>
            <div
              className="skeleton"
              style={{ width: "55%", height: "16px" }}
            ></div>
            <div
              className="skeleton"
              style={{ width: "55%", height: "16px" }}
            ></div>
          </div>
        ))}
      </div>

      {/* Right side: Donut Chart Skeleton */}
      <div
        style={{
          flexBasis: "200px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="skeleton"
          style={{ width: "150px", height: "150px", borderRadius: "50%" }}
        ></div>
      </div>
    </div>
  );
};

// Skeleton for Line Chart
export const LineChartSkeleton = () => {
  return (
    <div style={{ marginTop: "1rem" }}>
      <div
        className="skeleton"
        style={{ width: "100%", height: "300px" }}
      ></div>
    </div>
  );
};

// Skeleton for Simple Number Cards
export const NumberCardSkeleton = () => {
  return (
    <div style={{ display: "flex", }}>
      <div
        className="skeleton"
        style={{ width: "70px", height: "30px",margin:"0px" }}
      ></div>
    </div>
  );
};
